import { RouteRecordRaw } from "vue-router"
import GuardianRunner from "@/router/guardian-runner"
import { ensureIsAuthenticated } from "@/router/guardians"

const routes: Array<RouteRecordRaw> = [
  {
    path: "/phone-claim",
    name: "phone-claim",
    component: () => import("@/modules/phone-claim/pages/PhoneClaimPage.vue"),
    beforeEnter: (to, from, next) => GuardianRunner.run(to, from, next, [ensureIsAuthenticated])
  }
]

export default routes
